import { BaseService } from './base-service';
import {
	GetNotificationStatusRequestDTO,
	GetNotificationStatusResponseDTO
} from '@/core/dto/notification/get-notification';
import {
	UpdateNotificationStatusRequestDTO,
	UpdateNotificationStatusResponseDTO
} from '@/core/dto/notification/update-notification';

export class NotificationService extends BaseService<GetNotificationStatusResponseDTO> {
	private static instance: NotificationService;

	private constructor(public readonly basePath: string = '/notification') {
		super();
	}

	public static getInstance(): NotificationService {
		if (!NotificationService.instance) {
			NotificationService.instance = new NotificationService();
		}
		return NotificationService.instance;
	}

	public async getNotificationStatus(
		params: GetNotificationStatusRequestDTO
	): Promise<GetNotificationStatusResponseDTO> {
		const url = `${this.basePath}/v2/user-preference`;
		const { data } = await this.getInstance().get<GetNotificationStatusResponseDTO>(url, {
			params
		});
		return data;
	}

	public async updateNotificationStatus(
		params: UpdateNotificationStatusRequestDTO
	): Promise<UpdateNotificationStatusResponseDTO> {
		const url = `${this.basePath}/v2/user-preference`;
		const { data } = await this.getInstance().put<UpdateNotificationStatusResponseDTO>(url, params);
		return data;
	}
}
